partners.component('partners.partnersComponent', {
    templateUrl: 'partners/partners.html',
    controller: 'partners.partnersController',
    controllerAs: '$ctrl'
});

partners.controller('partners.partnersController', ['$state', 'coreFb', function($state, $fb){
    const $ctrl = this;

    $ctrl.$onInit = () => {
        $state.params.showGlobalLoading = false;
    }

}]);